import { FC, PropsWithChildren } from "react";

import { TabsProps } from "@mui/material";

import * as Styled from "./styles";

type TTabs = TabsProps &
  PropsWithChildren & {
    isFirstTabSelected?: boolean;
  };

export const MobileCatalogTabs: FC<TTabs> = (props) => {
  const { children, ...restProps } = props;
  return <Styled.Tabs {...restProps}>{children}</Styled.Tabs>;
};
